import { Injectable } from '@angular/core';
import { addSubPlans, addSubPlansCatalogs, getCatalogueCategories, getPermissions, getSubPlan, getSubPlanViewById, updatePlanStatus, updateSubscriptionPlan, updateSubscriptionPlanCatalog } from '../queries/addplan.query';

import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { ToastService } from 'src/app/core/toast.service';

@Injectable({
  providedIn: 'root'
})
export class PlansService {

  constructor(private apollo: Apollo, private toast:ToastService) { }

  getCatalogueCategories(): Observable<any> {
    return this.apollo.use("external").subscribe({
      query : getCatalogueCategories
    }).pipe(pluck('data', 'catalogue_categories'));
  }

  getPermissionsMaster(){

    return this.apollo.use("external").subscribe({
      query : getPermissions
    }).pipe(pluck('data', 'permissions'));

  }

  async addSubscriptionPlans(subPlans):Promise<any>{
    console.log(subPlans)
  
    try{
      
     return await this.apollo.use("external").mutate({
      mutation: addSubPlans,
      variables: {subPlans}
    }).pipe(pluck('data', 'insert_subscription_plans_one')).toPromise();
    //  this.toast.openSnackBar(
    //       'subscription plan added successfully'
    //     );
        //return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To add subscription plan');
            return false
           }
    
  }


 async addCatelaoCatsData(catagoriesData):Promise<any>{

  console.log(catagoriesData)

 //const catagoriesData = {catagoriesData:catagoriesCount}
  try{
      
     await this.apollo.use("external").mutate({
     mutation: addSubPlansCatalogs,
     variables: {catagoriesData}
   }).pipe(pluck('data', 'insert_subscription_plans_catalogues_categories_one')).toPromise();
   //  this.toast.openSnackBar(
   //       'subscription plan added successfully'
   //     );
       //return true
   }catch (err) {
           console.log(err);
           //this.toast.openSnackBar('You Failed To add subscription plan');
           return false
          }
   
 }

  


 getSubscriptionPlans(): Observable<any>{

  return this.apollo.use("external").subscribe({
    query : getSubPlan
  }).pipe(pluck('data', 'subscription_plans'));

}


updatePlanStarus(id,updateObj){
  console.log(id)
  //const updateObj = {updateObj:statusData}
  console.log(updateObj)
    return  this.apollo.use("external").mutate({
      mutation: updatePlanStatus,
      variables: {id,updateObj}
    }).pipe(pluck('data', 'update_subscription_plans_by_pk'));

    

  }


  getViewPlanById(id){
    console.log(id)
    return  this.apollo.use("external").mutate({
      mutation: getSubPlanViewById,
      variables: {id}
    }).pipe(pluck('data', 'subscription_plans_by_pk'));

  }

// New method to get subscription plan by ID
  getSubscriptionPlanById(id: string, formValues?: any): Observable<any> {
    return this.apollo.use("external").mutate({
      mutation: getSubPlanViewById,
      variables: { id }
    }).pipe(pluck('data', 'subscription_plans_by_pk'));
  }

  // New method to update subscription plan
  async updateSubscriptionPlan(id: string, planData: any): Promise<any> {
    try {
      return await this.apollo.use("external").mutate({
        mutation: updateSubscriptionPlan,
        variables: { id, planData }
      }).pipe(pluck('data', 'update_subscription_plans_by_pk')).toPromise();
    } catch (err) {
      console.log(err);
      this.toast.openSnackBar('Failed to update subscription plan');
      return false;
    }
  }

  // New method to update subscription plan catalog
  async updateCatelaoCatsData(id: string, catalogData: any): Promise<any> {
    try {
      return await this.apollo.use("external").mutate({
        mutation: updateSubscriptionPlanCatalog,
        variables: { id, catalogData }
      }).pipe(pluck('data', 'update_subscription_plans_catalogues_categories_by_pk')).toPromise();
    } catch (err) {
      console.log(err);
      return false;
    }
  }


}
